<template>
	<div>
		<el-tabs type="border-card" style="margin-top: 20px;">
			<el-tab-pane label="中奖列表">
				<el-table :data="winningData" style="width: 100%">
					<el-table-column prop="order_sn" label="中奖单号"> </el-table-column>
					<el-table-column prop="name" label="中奖人"> </el-table-column>
					<el-table-column prop="mobile" label="中奖人手机"> </el-table-column>
					<el-table-column prop="address" label="收货地址"> </el-table-column>
					<el-table-column prop="award_name" label="奖品名"> </el-table-column>
					<el-table-column prop="award_type" label="奖品类型">
						<template slot-scope="scope">
							<span
								v-text="
									scope.row.award_type == 1
										? '优惠券'
										: scope.row.award_type == 2
										? '积分'
										: scope.row.award_type == 3
										? '实物'
										: scope.row.award_type == 4
										? '余额'
										: '谢谢参与'
								"
							></span>
						</template>
					</el-table-column>
					<el-table-column prop="status" label="订单状态">
						<template slot-scope="scope">
							<el-select
                disabled
								v-model="scope.row.status"
								size="small"
								style="width: 100px;"
								@change="status_change($event, scope.row.id)"
							>
								<el-option
									v-for="item in options"
									:key="item.value"
									:label="item.label"
									:value="item.value"
									:disabled="disabled"
								>
								</el-option>
							</el-select>
						</template>
					</el-table-column>
					<el-table-column label="操作">
						<template slot-scope="scope">
							<!-- <el-button size="small" @click="winning_del(scope.row)"
								>删除</el-button
							> -->
							<el-button
								type="primary"
								size="small"
								@click="winning_info(scope.row)"
								>详情</el-button
							>
							
						</template>
					</el-table-column>
				</el-table>
				<el-pagination
					style="float: right;margin-top: 20px;"
					background
					:page-size="pageSize"
					layout="prev, pager, next"
					:total="total"
					@current-change="currentChange"
				>
				</el-pagination>
			</el-tab-pane>
		</el-tabs>
		
	</div>
</template>
<script>
import { del_winn, winn_status, winning_Data } from "@/api/vip";
import store from "@/store/index";

export default {
	data() {
		return {
      title:'',
			pageSize: 10,
			page: 1,
			total: 0,
			winningData: [],
			order_sn: "",
			IsWrite_off: false,
			options: [
				{
					label: "待核销",
					value: 0,
				},
				{
					label: "已核销",
					value: 2,
				},
			],
			disabled: false,
		};
	},
	mounted() {
		this.get_winning_Data();
	},
	methods: {
		//分页
		currentChange(val) {
			this.page = val;
			this.get_winning_Data();
		},
		
		//获取抽奖列表
		async get_winning_Data() {
			try {
				const res = await winning_Data({
					app_id: store.getters.app_id,
				});
				if (res.code == 200) {
					let arr = [];
					console.log(res);
					res.data.forEach((item) => {
						if (item.prize_id == this.$route.query.id) {
							arr.push(item);
						}
					});
					this.total = arr.length;
					this.winningData = arr.slice(
						(this.page - 1) * this.pageSize,
						this.page * this.pageSize
					);
          console.log(arr)
				}
			} catch (e) {
				console.log(e);
			}
		},
		//修改订单状态
		async status_change(val, id) {
			const res = await winn_status({
				app_id: store.getters.app_id,
				id: id,
				status: val,
			});
			if (res.code == 200) {
				console.log(res);
				this.$message.success(res.msg);
			} else {
				this.$message.error(res.msg);
			}
		},
		winning_info(row) {
			this.$router.push({
				path: "/apply/newVip/13/market/marketing/client/lottery/winningInfo",
				query: {
					id: row.id,
				},
			});
		},
		async winning_del(row) {
			const res = await del_winn({
				app_id: store.getters.app_id,
				id: row.id,
			});
			if (res.code == 200) {
				this.$message.success(res.msg);
			} else {
				this.$message.error(res.msg);
			}
		},
	},
};
</script>
<style lang="scss" scoped></style>
